
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import DevHome from './srm/demo/DevHome'
import SrmPage from './srm/login/login.vue'


export default {
data () {
return {
}
},
components: {
Grid,
GridItem,
XButton,
DevHome,
SrmPage,
},
computed: {

},

methods: {

},
created(){

},
mounted(){

},
}





// WEBPACK FOOTER //
// ./src/page/Home.vue